import React from 'react';

const SvgDogs = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  fillRule: "nonzero",
  d: "M81.29 91.978H23.881v-18.02c0-14.856 12.042-26.892 26.904-26.892h3.623c14.862 0 26.904 12.036 26.904 26.891v18.021h-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  fillRule: "nonzero",
  d: "M71.542 77.488c-12.088 4.359-25.912 4.359-38 0V62.329c12.088-4.359 25.912-4.359 38 0v15.159z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8D8D8D",
  fillRule: "nonzero",
  d: "M74.195 57.801c0 14.096-15.86 15.419-21.74 22.185-5.533-7.243-21.74-8.089-21.74-22.185 0-14.096 9.742-25.525 21.74-25.525 11.998 0 21.74 11.43 21.74 25.525z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  fillRule: "nonzero",
  d: "M78.535 43.51c0 13.25-12.67 32.507-26.535 16.481-13.191 16.807-26.535-3.23-26.535-16.481C25.465 30.26 37.355 12 52 12s26.535 18.26 26.535 31.51z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8D8D8D",
  d: "M41.765 31.726a.885.885 0 001.217-.037.806.806 0 00-.039-1.17c-1.177-1.062-2.56-1.604-4.109-1.604-1.539 0-2.954.534-4.216 1.58a.806.806 0 00-.09 1.169.885.885 0 001.215.086c.957-.794 1.977-1.18 3.091-1.18 1.105 0 2.069.379 2.931 1.157zM68.235 31.726a.885.885 0 001.217-.037.806.806 0 00-.039-1.17c-1.177-1.062-2.56-1.604-4.109-1.604-1.539 0-2.955.534-4.216 1.58a.806.806 0 00-.09 1.169.885.885 0 001.215.086c.956-.794 1.977-1.18 3.091-1.18 1.105 0 2.069.379 2.931 1.157z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  fillRule: "nonzero",
  d: "M52 72.57c-4.144 0-7.55-3.405-7.55-7.548v-7.46c0-4.142 3.406-7.546 7.55-7.546s7.55 3.404 7.55 7.546v7.46c0 4.143-3.406 7.547-7.55 7.547z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  fillRule: "nonzero",
  d: "M52 15.101c.824 0 1.497.65 1.497 1.475.065 6.289.76 17.284 8.375 20.84 3.884 1.822 4.383 7.417 4.34 12.708-.022 5.552-.782 10.778-5.316 11.776C53.497 63.548 52 55.242 52 55.242s-1.497 8.306-8.896 6.658c-4.512-.998-5.272-6.224-5.315-11.776-.022-5.291.455-10.886 4.34-12.708 7.615-3.556 8.309-14.551 8.374-20.84 0-.824.673-1.475 1.497-1.475z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8D8D8D",
  fillRule: "nonzero",
  d: "M62.393 47.045c0 3.795-4.643 8.5-10.393 8.5-5.728 0-10.393-4.705-10.393-8.5S46.25 41.797 52 41.797c5.728 0 10.393 1.453 10.393 5.248z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  fillRule: "nonzero",
  d: "M44.385 14.429c3.34-3.492-11.782 5.833-20.981 5.703-8.05-.108.65 35.587 1.041 30.23 1.195-16.74 16.577-32.442 19.94-35.932zM59.615 14.429c-3.34-3.492 11.782 5.833 20.981 5.703 8.05-.108-.65 35.587-1.041 30.23-1.195-16.74-16.598-32.442-19.94-35.932z"
})));

export default SvgDogs;